import {Card,CardBody,CardHeader, CardFooter} from 'reactstrap';
import { Image } from '@mui/icons-material';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { relative } from 'path';
import './cardIcon.css'
import { Tooltip } from '@mui/material';
//rte
interface datosIcono{
    imagen: string,
    texto: string,
    backColor: string,
    enlace: string
    habilitar: boolean
    backColorDeshabilitar: string,
    toolTipText?: string 
  }

export default function CardIcono(props: datosIcono) {
    return (
      props.habilitar ? 
      <div className='contenedor'>
            {/* <div className='imagen' onClick={() => redireccionar(props.enlace)} style={{background: props.backColor, borderRadius: '20px', height:225, width:225, display:'flex', justifyContent: 'center', alignItems: 'center' }}> */}
            <a href={props.enlace}>
              <div className='imagen' style={{background: props.backColor, borderRadius: '20px', height:225, width:225, display:'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <div style={{textAlign: 'center'}}>
                      <img src={props.imagen} alt="" height={75} width={75} />
                      <p style={{color:'white', paddingTop: '15px'}} >{props.texto}</p>
                  </div>
              </div>
            </a>
      </div>
      :
      <div>
        <Tooltip title={props.toolTipText} placement="top" arrow>
          <div className='imagen' style={{background: props.backColorDeshabilitar, borderRadius: '20px', height:225, width:225, display:'flex', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{textAlign: 'center'}}>
                  <img src={props.imagen} alt="" height={75} width={75} />
                  <p style={{color:'white', paddingTop: '15px'}} >{props.texto}</p>
              </div>
          </div>
          </Tooltip>
      </div>
    );
  }

  function redireccionar(redir:string){
    window.location.href=redir
  }